import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-contact_method_10",
  "use": "icon-contact_method_10-usage",
  "viewBox": "0 0 18 18",
  "content": "<symbol viewBox=\"0 0 18 18\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-contact_method_10\">\n<path d=\"M2.33317 14H3.99984V17.4008L8.25067 14H12.3332C13.2523 14 13.9998 13.2525 13.9998 12.3333V5.66667C13.9998 4.7475 13.2523 4 12.3332 4H2.33317C1.414 4 0.666504 4.7475 0.666504 5.66667V12.3333C0.666504 13.2525 1.414 14 2.33317 14Z\" fill=\"#314455\" />\n<path d=\"M15.6667 0.666504H5.66667C4.7475 0.666504 4 1.414 4 2.33317H14C14.9192 2.33317 15.6667 3.08067 15.6667 3.99984V10.6665C16.5858 10.6665 17.3333 9.919 17.3333 8.99984V2.33317C17.3333 1.414 16.5858 0.666504 15.6667 0.666504Z\" fill=\"#314455\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/svgIcon/svg/contact_method_10.svg
// module id = jw2M
// module chunks = 262